import { render, staticRenderFns } from "./MemberEdit.vue?vue&type=template&id=35dedb08&"
import script from "./MemberEdit.vue?vue&type=script&lang=ts&"
export * from "./MemberEdit.vue?vue&type=script&lang=ts&"
import style0 from "./MemberEdit.vue?vue&type=style&index=0&id=35dedb08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports